import useGetDefaultStack from '@hooks/api/queries/modes/useGetDefaultStack';
import { CircularProgress } from '@mui/material';
import ControlModeAuthority from '@src/components/Home/Config/Stacks/ControlModesAuthority';
import { useState } from 'react';
import './Stacks.scss';
import { isSuperAdmin } from '@src/services/auth';
import { UserRole } from '@src/services/auth/roles';
import storeConnector from '@store/storeConnector';
import StackModal from './StackModal';
import StackContent from './components/StackContent';

interface HMIDefaultProps {
  role: UserRole;
}

function HMIDefault({ role }: HMIDefaultProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const {
    data: defaultStack,
    isFetching,
    isRefetching,
    failureCount,
  } = useGetDefaultStack();

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  if ((isFetching || isRefetching) && !failureCount) {
    return <CircularProgress />;
  }

  const isAdmin = isSuperAdmin(role);

  return (
    <main className='stacks__main'>
      <ControlModeAuthority />
      <section className='stacks__wrapper'>
        <StackContent
          defaultStack={defaultStack}
          isAdmin={isAdmin}
          onActionClick={handleModalOpen}
        />

        <StackModal
          stackId={defaultStack?.id}
          open={modalOpen}
          onClose={handleModalClose}
          isDefault={true}
        />
      </section>
    </main>
  );
}

export default storeConnector(HMIDefault, {
  user: ['role'],
});
